import { useEffect } from 'react';

const usePageTitle = (titleKey) => {

    useEffect(() => {
        const title = titleKey;
        document.title = `${title}`;
    }, [titleKey]);
};

export default usePageTitle; 